import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AbstractViewSettingsSliderComponent } from '../abstract-view-settings-slider.component';

@Component({
  selector: 'h3-view-settings-slider',
  templateUrl: './view-settings-slider.component.html',
  styleUrl: './view-settings-slider.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ViewSettingsSliderComponent
  extends AbstractViewSettingsSliderComponent<number>
  implements OnInit
{
  value$!: Observable<string>;

  override ngOnInit() {
    super.ngOnInit();

    this.value$ = this.settingStore.$.pipe(
      map((value) => this.formatValue(value)),
    );
  }

  setValue(event: Event) {
    const target = event.target as HTMLInputElement;
    const value = target.valueAsNumber;
    super.setValueAndTrackEvent(value, this.settingStore);
  }
}
